module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stream-browserify/~/readable-stream/transform.js
// module id = 426
// module chunks = 2